/**
 * Hero block — subtle crossfade between media slides
 */

document.querySelectorAll('.hero--split[data-slideshow-interval]').forEach((hero) => {
    const slides = hero.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const interval = parseInt(hero.dataset.slideshowInterval, 10) || 5000;
    let current = 0;

    window.setInterval(() => {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');

        current = (current + 1) % slides.length;

        slides[current].classList.add('is-active');
        slides[current].removeAttribute('aria-hidden');
    }, interval);
});
